
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship  </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>2nd G H Raisoni Memorial Bhandara District  <span>Open  Chess Championship
                2024</span></h2>
        </div>
        <div class="row">
            <div class="col-md-12 up-event-text">

                <h6 class="fw-bold">Date of competition :-21<sup>st</sup> April 2024</h6>
                <h6 class="fw-bold">Venue :- Badminton Hall, Krida Sankul, Bhandara</h6>
                <p class="text-justify">2nd G H Raisoni Memorial Bhandara District Open Chess Championship 2024 Under the Aegis of Maharashtra Chess Association & Classic & Rapid Chess Circle Association, Bhandara Organized By G H Raisoni Sports & Cultural Foundation and Kalpana Prakash Welfare Foundation, Nagpur</p>


            </div>

        </div>
    </div>
</section>
<!-- <section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Result</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/result-sada-rai-wom-batmtn-24.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>

                <div class="gall-ery mt-5">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-1.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-2.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-3.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-6.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-5.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-4.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media</h4>
                            </div>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-1.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-2.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-3.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-4.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-5.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-6.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-7.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-7.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-7.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-8.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-8.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-8.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-14.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-14.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-14.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-9.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-9.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-9.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-10.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-12.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-12.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-12.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-13.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-13.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-sada-rai-wom-batmtn-13.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section> -->
